<template>
  <vk-dialog
    :visible.sync="visible"
    @close="closeDialog"
    title="请选择孩子"
  >

    <div class="choose-dialog-content">
      <ul>
        <li
          class="child-module"
          v-for="item in list"
          :key="item.id"
          @click="chooseStudent(item)"
        >
          <div class="img-module">
            <img :src="item.avatar" />
            <div
              class="checked-module"
              :class="{'checked': chooseItemId === item.id}"
            >
              <img src="@/assets/images/detail/checked.svg" />
            </div>
          </div>
          <span class="name">{{item.name}}</span>
        </li>
      </ul>
    </div>
    <div class="choose-dialog-footer">
      <span
        @click="sure"
        :class="{'disabled' : !chooseItemId}"
        vkshop-event-name="chooseChild"
        :vkshop-event-param="'studentId=' + chooseItemId"
        vkshop-event-type="click"
      >确认</span>
    </div>
  </vk-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: []
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      chooseItemId: ''
    }
  },
  watch: {
    visible: function (newVal, oldVal) {
      newVal && (this.chooseItemId = Number(this.id))
    }
  },
  methods: {
    chooseStudent(item) {
      this.chooseItemId = item.id
    },
    sure() {
      if (this.chooseItemId) {
        this.$emit('update:id', this.chooseItemId)
        this.$emit('sure')
        this.closeDialog()
      }
    },
    closeDialog() {
      this.$emit('update:visible', false)
      this.chooseItemId = ''
    }
  }
}
</script>

<style lang="less" scoped>
.choose-dialog-content {
  padding: 64px 52px 56px;
  ul {
    cursor: pointer;
    width: 100%;
    overflow: auto;
    padding: 0;
    margin: 0;
    border: 0;
    white-space: nowrap;
    .child-module {
      display: inline-block;
      min-width: 192px;
      margin: 0 20px;
      .img-module {
        position: relative;
        height: 110px;
        width: 110px;
        border-radius: 50%;
        overflow: hidden;
        margin: 0 auto 16px;
        img {
          display: block;
          height: 100%;
          width: 100%;
        }
        .checked-module {
          display: none;
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          img {
            width: 40px;
            margin: auto;
          }
          &.checked {
            display: block;
          }
        }
      }

      .name {
        width: 100%;
        text-align: center;
        color: #000000;
        font-size: 24px;
        line-height: 33px;
        display: inline-block;
      }
    }
  }
}
.choose-dialog-footer {
  text-align: center;
  span {
    cursor: pointer;
    display: inline-block;
    width: 210px;
    height: 56px;
    line-height: 56px;
    margin-bottom: 36px;
    background-color: #f85415;
    color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(255, 103, 26, 0.2),
      0px 5px 10px 0px rgba(255, 103, 26, 0.4);
    border-radius: 26px;
    text-align: center;
    font-size: 18px;
    &.disabled {
      background-color: #d0d0d0;
      box-shadow: none;
      cursor: not-allowed;
    }
  }
}
</style>
